import { render, staticRenderFns } from "./selectRecipient.vue?vue&type=template&id=0b6124c0&scoped=true"
import script from "./selectRecipient.vue?vue&type=script&lang=js"
export * from "./selectRecipient.vue?vue&type=script&lang=js"
import style0 from "./selectRecipient.vue?vue&type=style&index=0&id=0b6124c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6124c0",
  null
  
)

export default component.exports